export default "__VITE_ASSET__8cb7f1aa__"